module.exports = __webpack_public_path__ + "static/media/Light_Divider@3x.702cf30e.png";